import notify from "devextreme/ui/notify";
import {cacheFormsContent} from "../utils/formCache"
var md5 = require("md5");

//  process.env;
const { REACT_APP_SERVER_URL } = process.env;

export async function signIn(email, password) {
  try {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      // mode: 'no-cors',
      body: JSON.stringify({ Email: email, Password: password }),
    };
    var userData = {};
    const response = await fetch(
      `${REACT_APP_SERVER_URL}SignIn`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => (userData = data));
    localStorage.setItem("guid", JSON.stringify(userData.guid));

    if (userData.isOK) {
      return {
        isOk: true,
        data: userData.guid,
        phone: userData.phone,
      };
    } else {
      return {
        isOk: false,
        message: response.Message || "האימות נכשל, אימייל או ססמא לא נכונים",
        //message: "האימות נכשל, אימייל או ססמא לא נכונים",
        //message: "Authentication failed, Incorrect Email or Password"
      };
    }
  } catch (e) {
    return {
      isOk: false,
      message: "האימות נכשל",
    };
  }
}


export async function sendToken(token) {
  const guid = JSON.parse(localStorage.getItem("guid"));
  try {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      credentials: "include",
      //mode: 'cors',
      body: JSON.stringify({ Token: token, Guid: guid }),
    };
    // Send request
    var userData = {};
    // var item;

    const response = await fetch(
      `${REACT_APP_SERVER_URL}Validation2`,
      requestOptions
    )
      .then((response) => response.json())
      .then((data) => (userData = data));

    if (userData.isOk) {
      localStorage.removeItem("guid");


      if (userData.form && Array.isArray(userData.form.listOfForms)) {
        cacheFormsContent(userData.form.listOfForms);
      }
      return {
        isOk: true,
        data: userData,
      };
    } else {
      return {
        isOk: false,
        message: response.Message || "האימות נכשל, הטוקן פג תוקף",
        //message: "Authentication failed, Token Expierd"
      };
    }
  } catch (e) {
    return {
      isOk: false,
      message: "האימות נכשל",
      //message: "Authentication failed"
    };
  }
}

export async function logOut() {
  try {
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      credentials: "include",
      //mode: 'cors',
    };
    const response = await fetch(
      `${REACT_APP_SERVER_URL}Logout`,
      requestOptions
    ).then((response) => response.json());
  } catch (e) {
    return {
      isOk: false,
      message: "האימות נכשל",
      //message: "Authentication failed"
    };
  }
}

export async function getUser() {
  var userData = {};
  try {
    // Send request
    const response = await fetch(`${REACT_APP_SERVER_URL}getUser`, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => response.json())
      .then((data) => (userData = data));
    if (userData.isOk) {
      return {
        isOk: true,
        data: userData,
      };
    } else {
      return {
        isOk: false,
        message: "תם זמן הפעילות. אנא התחבר מחדש",
      };
    }
  } catch (e) {
    return {
      isOk: false,
      message: "האימות נכשל",
      //message: "Authentication failed"
    };
  }
}

export async function createAccount(email, password) {
  try {
    // Send request
    const safePW = md5(password);
    const userDetails = {
      mail: email,
      pw: safePW,
    };
    const requestOptions = {
      method: "POST",
      headers: {
        Allow: "POST",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
      mode: "no-cors",
      body: JSON.stringify(userDetails),
    };
    const response = await fetch(
      `${REACT_APP_SERVER_URL}CreatAccount?mail=${email}&pw=${safePW}`,
      requestOptions,
      {
        method: "POST",
        headers: {
          Allow: "POST",
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
        mode: "no-cors",
        //body: JSON.stringify(userDetails)
      }
    ).then((response) => response.json());

    return {
      isOk: true,
    };
  } catch {
    return {
      isOk: false,
      message: "Failed to create account",
    };
  }
}

export async function changePassword(password, otp, email) {
  // Send request
  const data = {
    Email: email,
    Password: password,
    Token: otp,
  };
  const response = await fetch(`${REACT_APP_SERVER_URL}ChangePassword`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  if (response.ok) {
    const msg = "הסיסמא הוחלפה בהצלחה";
    notify(msg, "success", 3000);
    return {
      isOk: true,
    };
  } else {
    const msg = "יש טעות במייל או בסיסמא";
    notify(msg, "error", 3000);
    return {
      isOk: false,
      message: "Failed to change password",
    };
  }
}

export async function resetPassword(email) {
  // Send email to server
  const response = await fetch(
    `${REACT_APP_SERVER_URL}ChangePassword?e=${email}`,
    {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
    }
  );
  if (response.ok) {
    return {
      isOk: true,
    };
  }
  return {
    isOk: false,
    message: "Failed to reset password. The email does not exist in our system",
  };
}
